<div class="groups">
    <div class="lg:w-full mx-auto py-3 px-6">
        <div class="filters w-full flex flex-wrap justify-content-around gap-2">
            <div class="filter-row">
                <span class="mr-3">Make: </span>
                <p-dropdown
                        [options]="makes"
                        [(ngModel)]="selectedMake"
                        (onClear)="onMakesClear()"
                        (onChange)="loadImages({})"
                        optionLabel="name"
                        [filter]="true"
                        filterBy="name"
                        [showClear]="selectedMake != ALL_MAKES_SELECT"
                        [placeholder]="makesLoading ? 'Loading...' : 'Select make'"
                        [loading]="makesLoading"
                        [style]="{'width': '10vw'}"
                >
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div class="flex align-items-center justify-content-between">
                            <div>{{ selectedOption.name }}</div>
                            <p-badge
                                    *ngIf="selectedOption.no_approved_images_groups_count !== null"
                                    [pTooltip]="'Groups count without approved images'"
                                    [value]="selectedOption.no_approved_images_groups_count" />
                        </div>
                    </ng-template>
                    <ng-template let-make pTemplate="item">
                        <div class="flex align-items-center justify-content-between">
                            <div>
                                {{ make.name }}
                            </div>
                            <p-badge *ngIf="make.no_approved_images_groups_count !== null"
                                     [pTooltip]="'Groups count without approved images'"
                                     [value]="make.no_approved_images_groups_count" />
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="filter-row flex align-items-center ">
                <span class="mr-3">Group: </span>
                <div class="flex flex-column gap-2">
                    <p-iconField iconPosition="left">
                        <p-inputIcon styleClass="pi pi-search"/>
                        <input type="text" pInputText placeholder="Search by group name" [(ngModel)]="groupName"/>
                    </p-iconField>
                </div>
            </div>

            <div class="filter-row">
                <span class="mr-3">Max images: </span>
                <p-dropdown
                        [options]="maxImagesOptions"
                        [(ngModel)]="selectedMaxImages"
                        placeholder="Select"/>
            </div>
            <div class="filter-row">
                <p-button
                        label="Export CSV"
                        [loading]="csvExportLoading"
                        styleClass="w-full"
                        size="small"
                        (onClick)="exportCSV()"
                        [pTooltip]="'Export all approved images for all makes'"
                />
            </div>
            <p-button (onClick)="op.toggle($event)" icon="pi pi-filter" label="Filters"  size="small"/>
            <p-overlayPanel #op>
                <div class="flex flex-column gap-2">
                    <div class="filter-row">
                        <span class="mr-3">Show approved: </span>
                        <p-dropdown
                                [disabled]="selectedShowGroupsWithoutApprovedImages"
                                [loading]="this.imagesLoading"
                                [options]="defaultOptions"
                                [(ngModel)]="selectedShowApprove"
                                placeholder="Select"/>
                    </div>
                    <div class="filter-row flex align-items-center ">
                        <span class="mr-3">Show empty groups: </span>
                        <p-inputSwitch  [(ngModel)]="selectedShowGroups" (onChange)="loadImages({})" [disabled]="imagesLoading" />
                    </div>
                    <div class="filter-row flex align-items-center ">
                        <span class="mr-3">Show only groups used in DNA reports: </span>
                        <p-inputSwitch [(ngModel)]="selectedShowGroupOnlyUsedInDna" (onChange)="loadImages({})" [disabled]="imagesLoading"/>
                    </div>
                    <div class="filter-row flex align-items-center ">
                        <span class="mr-3">Show only groups without approved images: </span>
                        <p-inputSwitch [(ngModel)]="selectedShowGroupsWithoutApprovedImages" (onChange)="loadImages({})" [disabled]="selectedShowGroupsWithoutSafetyCostCaption || selectedShowGroupsWithoutNotes || imagesLoading"/>
                    </div>
                    <div class="filter-row flex align-items-center ">
                        <span class="mr-3">Show images without safety cost caption </span>
                        <p-inputSwitch [(ngModel)]="selectedShowGroupsWithoutSafetyCostCaption" (onChange)="loadImages({})" [disabled]="selectedShowGroupsWithoutApprovedImages ||selectedShowGroupsWithoutNotes || imagesLoading" />
                    </div>
                    <div class="filter-row flex align-items-center ">
                        <span class="mr-3">Show images without notes </span>
                        <p-inputSwitch [(ngModel)]="selectedShowGroupsWithoutNotes" (onChange)="loadImages({})" [disabled]="selectedShowGroupsWithoutApprovedImages || selectedShowGroupsWithoutSafetyCostCaption || imagesLoading" />
                    </div>

                </div>

            </p-overlayPanel>


        </div>
        <div class="w-2 mx-auto mt-3">
            <p-button label="Search" [loading]="imagesLoading" styleClass="w-full" size="small"
                      (onClick)="loadImages({})"/>
        </div>
    </div>
    <main>
        <p-table
                [first]="pTableFirst"
                [value]="images"
                [showCurrentPageReport]="true"
                [paginator]="true"
                [lazy]="true"
                [rows]="perPage"
                [loading]="imagesLoading"
                [totalRecords]="totalRecords"
                [tableStyle]=""
                (onLazyLoad)="loadImages($event)"
                [pageLinks]="10"
                [rowsPerPageOptions]="[10, 25, 50]">
            <ng-template pTemplate="header">
                <tr>
                    <th>Group</th>
                    <th>Images</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group>
                <tr [ngClass]="{'no-position-row': group[0][3] == -1 || group[0][3] == null}">
                    <td>
                        <div class="group" style="width: max-content">
                            <div class="group-info mb-3">
                                <small *ngIf="group[0][3] == -1 || group[0][3] == null" style="color: red">(not used in DNA reports currently)</small>
                                <div class="first-td mb-2">{{ group[0][1] }}</div>
                                <div><small> <strong>Occurrence</strong>: {{ group[0][2] | round: 2 }}</small></div>
                            </div>
                            <div class="group-actions flex justify-content-center gap-2">
                                <p-button
                                        label="Search"
                                        styleClass="w-half"
                                        size="small"
                                        (click)="openSearchImageGroupDialog(group[0])"/>
                                <p-button
                                        label="Upload"
                                        styleClass="w-half"
                                        size="small"
                                        (click)="openUploadImageGroupDialog(group[0])"/>
                            </div>
                        </div>

                    </td>
                    <td>
                        <div class="images">
                            @for (image of group[1]; track image.sjc_group_sjc_inspection_image_id) {
                                <p-card class="image"
                                        header="{{ image.topic_name }}"
                                        [style]="{ width: '360px' }">
                                    <ng-template pTemplate="header">
                                        <div style="position:relative">
                                            <p-image
                                                    src="https://insp-img.autotechiq.com/webp/{{ image.webp }}"
                                                    alt="Image"
                                                    [preview]="true"/>
                                            <div *ngIf="image.manual_upload"
                                                 style="position:absolute; top: 10px; right: 10px">
                                                <span style="background: white; padding: 5px; border-radius: 5px; text-align: center; display: flex;">
                                                    <i class="pi pi-upload"
                                                       [pTooltip]="'Manually uploaded image'"
                                                       style="font-size: 1.25rem; color:#3B82F6;"></i>
                                                </span>
                                            </div>
                                            <div *ngIf="image.failure_term"
                                                 (click)="onOpenEditSafetyAndCostCaptionDialog(image)"
                                                 style="position:absolute; bottom: 10px; left: 5px; cursor: pointer;">
                                                <span style="background: black; padding: 5px; border-radius: 5px; text-align: center; display: flex;font-size: 13px;color: white;">
                                                    {{ image.failure_term }}
                                                </span>
                                            </div>
                                            <div *ngIf="image.makes.length > 1"
                                                 style="position:absolute; bottom: 10px; right: 5px; cursor: pointer;background: black; padding: 5px; border-radius: 5px; text-align: center;">
                                                <i class="pi pi-car"
                                                   (mouseover)="op.toggle($event)"
                                                   style="font-size: 1.25rem; color:white"></i>
                                                <p-overlayPanel #op >
                                                    @for (make of image.makes; track make) {
                                                    <p>{{make}}</p>
                                                    }

                                                </p-overlayPanel>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="subtitle">
                                        <div class="subtitle flex justify-content-between align-items-center">
                                            <div class="flex align-items-center gap-2">
                                                {{ image.custom_sjc_name ?? image.action_name }}
                                                <span *ngIf="image.custom_sjc_name">
                                                    <i class="pi pi-exclamation-circle"
                                                       [pTooltip]="'Has custom Typical Repair'"
                                                       style="font-size: 1.25rem; color: red"></i>
                                                </span>
                                            </div>

                                            <p-button label="Edit" [text]="true"
                                                      (click)="openCustomSjcDialog(image)"></p-button>
                                        </div>
                                    </ng-template>
                                    <p-divider></p-divider>
                                    <p class="notes">
                                        <span class="flex align-items-center gap-2">
                                            <b>Notes:</b>
                                            @if (image.custom_caption) {
                                                <span>
                                                <i class="pi pi-pen-to-square"
                                                   [pTooltip]="'Has custom caption'"
                                                   style="font-size: 1.25rem; color: red"></i>
                                                </span>
                                            }
                                            <br>
                                        </span>
                                        <i>{{ image.custom_caption || image.caption }}</i>
                                    </p>

                                    <ng-template pTemplate="footer">
                                        <div class="approve mb-2">
                                            <p class="flex align-items-center justify-content-between mb-3">
                                                <span><strong>Approved: </strong></span>
                                                <p-checkbox
                                                        [(ngModel)]="image.approved"
                                                        [binary]="true"
                                                        inputId="binary"
                                                        class="checkbox-approve"
                                                        (onChange)="this.onChangeCheckbox(image, $event)"
                                                />
                                            </p>
                                        </div>
                                        <div class="flex justify-content-between">
<!--                                            <p class="mt-2">-->
<!--                                                <small>-->
<!--                                                    <strong>Arr: </strong> {{ image.score | round: 2 }},-->
<!--                                                    <strong>Rel: </strong>{{ image.image_option_score | round: 2 }}-->
<!--                                                </small>-->
<!--                                            </p>-->
                                            <div class="flex flex-wrap gap-2 align-items-center ">
                                                @if (image.approved_all_makes) {
                                                    <p-button
                                                            [pTooltip]="'Approved for all makes'"
                                                            icon="pi pi-list-check"
                                                            [rounded]="true"
                                                            [disabled]="image.approved_all_makes"
                                                            severity="success"/>
                                                } @else {
                                                    <p-button
                                                            [pTooltip]="'Approved for all makes'"
                                                            icon="pi pi-list-check"
                                                            [rounded]="true"
                                                            [outlined]="true"
                                                            [disabled]="image.approved_all_makes"
                                                            (onClick)="approveForAllMakes(group[0], image)"/>
                                                }

                                                <p-button
                                                        [pTooltip]="'Change group'"
                                                        icon="pi pi-cog"
                                                        [rounded]="true"
                                                        [outlined]="true"
                                                        (click)="this.setSelectableGroup(group[0][1]);image.groupDialogVisible = true;"/>
                                                <p-button
                                                        [pTooltip]="'Edit notes'"
                                                        icon="pi pi-pen-to-square"
                                                        [rounded]="true"
                                                        [outlined]="true"
                                                        (click)="this.dialogCaption = image.custom_caption || image.caption;image.captionDialogVisible = true;"/>
                                                <p-button
                                                        [pTooltip]="'Edit Safety and Cost Caption'"
                                                        icon="pi pi-file-edit"
                                                        [rounded]="true"
                                                        [outlined]="true"
                                                        (click)="onOpenEditSafetyAndCostCaptionDialog(image)"/>
                                                <p-button
                                                        [pTooltip]="'Edit image'"
                                                        icon="pi pi-image"
                                                        [rounded]="true"
                                                        [outlined]="true"
                                                        (click)="openEditImage(image, getGroup(group))"/>
                                                <p-button
                                                        [pTooltip]="'Delete'"
                                                        icon="pi pi-trash"
                                                        severity="danger"
                                                        [rounded]="true"
                                                        [outlined]="true"
                                                        (click)="deleteImage(image)"/>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-card>
                                <p-dialog
                                        header="Edit"
                                        [modal]="true"
                                        [(visible)]="image.groupDialogVisible"
                                        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
                                        [draggable]="false"
                                        [resizable]="false"
                                        [dismissableMask]="true"
                                >
                                    <div class="flex align-items-center gap-3 mb-2">
                                        <label class="font-semibold w-6rem">Group: </label>
                                        <p-dropdown
                                                appendTo="body"
                                                [options]="groups"
                                                [(ngModel)]="selectedGroup"
                                                optionLabel="name"
                                                [filter]="true"
                                                filterBy="name"
                                                [placeholder]="groupLoading ? 'Loading...' : 'Select group'"
                                                [loading]="groupLoading"
                                        >
                                            <ng-template pTemplate="selectedItem" let-selectedOption>
                                                <div class="flex align-items-center gap-2">
                                                    <div>{{ selectedOption.name }}</div>
                                                </div>
                                            </ng-template>
                                            <ng-template let-group pTemplate="item">
                                                <div class="flex align-items-center gap-2">
                                                    <div>{{ group.name }}</div>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>
                                    <div class="flex justify-content-end gap-2">
                                        <p-button label="Cancel" severity="secondary"
                                                  (click)="image.groupDialogVisible = false"/>
                                        <p-button
                                                label="Save"
                                                (onClick)="image.groupDialogVisible = false; this.updateImageGroup(image)"
                                                [disabled]="this.selectedGroup && this.selectedGroup.name === group[0][0]"/>
                                    </div>
                                </p-dialog>


                                <p-dialog
                                        header="Edit"
                                        [modal]="true"
                                        [(visible)]="image.captionDialogVisible"
                                        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
                                        [draggable]="false"
                                        [resizable]="false"
                                        [dismissableMask]="true"
                                >
                                    <div class="mb-2">
                                        <label class="font-semibold w-10rem mb-2">Custom caption: </label>
                                        <div class="flex flex-column gap-2 mt-2">
                                          <textarea
                                                  rows="5"
                                                  cols="30"
                                                  pInputTextarea
                                                  [(ngModel)]="dialogCaption">
                                          </textarea>
                                        </div>
                                    </div>
                                    <p-button
                                            label="Reset"
                                            severity="primary"
                                            (onClick)="this.resetCaption(image)"
                                    />
                                    <div class="flex justify-content-end gap-2">
                                        <p-button label="Cancel" severity="secondary"
                                                  (click)="image.captionDialogVisible = false"/>
                                        <p-button
                                                label="Save"
                                                (onClick)="image.captionDialogVisible = false; this.updateImageCaption(image)"
                                        />
                                    </div>
                                </p-dialog>


                            }
                            @if (group[1].length === 0) {
                                <span>No image candidates</span>
                            }
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <app-approve-all-makes-btn
                [dialogVisible]="approveAllMakesDialogVisible"
                (onVisibilityChanged)="onVisibilityApproveDialogChange($event)"/>
        <app-delete-confirmation-dialog
                [dialogVisible]="deleteImageDialogVisible"
                (onVisibilityChanged)="onVisibilityDeleteDialogChange($event)"
                (onSuccess)="refresh()"
        />
        <app-groups-image-search
                [group]="groupImageSearch!"
                [makes]="makes"
                (onApprovedImage)="refresh()"
                (onImageUploadEvent)="refresh()"/>
        <app-image-upload
                [group]="groupImageSearch!"
                [makes]="makes"
                [sjcs]="sjcs"
                (onImageUploadEvent)="refresh()"/>
        <app-image-editor
                (onImageUploadEvent)="refresh()"/>
        <app-custom-sjc-dialog
                [sjcs]="sjcs"
                (onImageUpdated)="refresh()"/>
        <app-safety-cost-caption-dialog
            [dialogVisible]="safetyCostCaptionDialogVisible"
            (onVisibilityChanged)="onVisibilitySafetyCostDialogChange($event)"
            (onSuccess)="refresh()"
        />

    </main>
</div>
